// extracted by mini-css-extract-plugin
module.exports = {"numN":"Impact_numN__oLm5H","trackingNumbers":"Impact_trackingNumbers__zU0Ql"};